<template>
  <div>
    <el-container direction="vertical">
      <div style="background-color: rgb(255, 255, 255); border: 1px solid #eee;">
        <div>
          <el-form label-width="120px" :inline="true" style="margin-top: 20px; margin-left: 0px">
            <el-form-item label="机构">
              <select-tree @input="input"></select-tree>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="listQuery.patientName"></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input v-model="listQuery.idcard"></el-input>
            </el-form-item>
            <el-form-item label="糖尿病评分">
              <el-select style="margin-left: 10px" v-model="scoreLevel" placeholder="选择">
                <el-option v-for="item in scoreLevelOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="margin-left: 20px" @click="getList">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="reportExportToExcel">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table v-loading="listLoading" :data="list" height="635" border fit highlight-current-row
          style="width: 100%; margin-left: 0px">
          <el-table-column width="120px" align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.patientName }}</span>
            </template>
          </el-table-column>

          <el-table-column width="200px" align="center" label="证件号">
            <template slot-scope="scope">
              <span>{{ scope.row.idcard }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="性别">
            <template slot-scope="scope">
              <span>{{ getGender(scope.row.gender) }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="年龄">
            <template slot-scope="scope">
              <span>{{ scope.row.age }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="腰围（cm）">
            <template slot-scope="scope">
              <span>{{ scope.row.waist }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="BMI">
            <template slot-scope="scope">
              <span>{{ Number(scope.row.bmi).toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="收缩压">
            <template slot-scope="scope">
              <span>{{ scope.row.sbp }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="舒张压">
            <template slot-scope="scope">
              <span>{{ scope.row.dbp }}</span>
            </template>
          </el-table-column>

          <el-table-column width="120px" align="center" label="糖尿病家族史">
            <template slot-scope="scope">
              <span>{{ getPatientDiabets(scope.row.diabetFamily) }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="评分结果">
            <template slot-scope="scope">
              <span>{{ scope.row.score }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100px" align="center" label="风险级别">
            <template slot-scope="scope">
              <span>{{ scope.row.riskName }}</span>
            </template>
          </el-table-column>

          <el-table-column width="200px" align="center" label="所属机构">
            <template slot-scope="scope">
              <span>{{ scope.row.managerHospital }}</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button style="margin-left: 0px; align-self: center" type="text" @click="patientsDetail(scope.row)">
                健康档案
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="pageNum" :limit.sync="pageSize"
          @pagination="getList" />

        <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
      </div>
    </el-container>
  </div>
</template>

<script>
import { getPatientEasyillDiabetsList } from "@/api/health/EhrQuery";
import { getSearchList, reportToExcel, getSysDicList } from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import patientDetail from "@/views/patient/patientDetail";
import SelectTree from '@/components/selectTree';
import { Loading } from "element-ui";
import moment from "moment";

export default {
  components: { Pagination, patientDetail, SelectTree },
  data() {
    return {
      patientDetailVisible: false,
      list: null,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      listLoading: false,
      loadingOptions: {
        text: "正在导出...",
        background: "rgba(0, 0, 0, 0.6)",
      },
      listQuery: {
        managerHospitals: [],
        patientName: null,
        idcard: null,
        scoreLe: null,
        scoreGt: null
      },
      scoreLevelOptions: [
        {
          value: "1",
          label: "全部",
        },
        {
          value: "2",
          label: "≥25分",
        },
        {
          value: "3",
          label: "<25分",
        },
      ],
      scoreLevel: "1",
      familyHistoryOptions: [
        {
          value: "0",
          label: "不详",
        },
        {
          value: "1",
          label: "有家族史",
        },
        {
          value: "2",
          label: "无家族史",
        },
      ],
      exportBody: {
        url: '/business/patientEasyillDiabets/list?page=' + this.pageNum + '&pageSize=' + this.pageSize,
        headers: ['姓名', '证件号', '性别', '年龄', '腰围（cm）', 'BMI', '收缩压', '舒张压', '糖尿病家族史', '评分结果', '风险级别', '所属机构'],
        keys: ['patientName', 'idcard', 'gender', 'age', 'waist', 'bmi', 'sbp', 'dbp', 'diabetFamily', 'score', 'riskName', 'managerHospital'],
        body: null,
      },
      sexOptions: []
    };
  },
  created() {
    var typeData = "性别";
    this.getSystemDictList(typeData);
    // this.getList();
  },
  activated() {
    // this.getList();
  },
  methods: {
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records;
      }).catch(err => {
        console.log(err);
      })
    },
    getGender(gender) {
      var option = this.sexOptions.filter(v => v.value == gender)[0];
      return option.name;
    },
    //查询结果导出
    reportExportToExcel() {
      console.log(
        "查询结果导出",
        `表格${moment(new Date()).format("YYYYMMDDHHmm")}.xlsx`
      );

      let loadingInstance = Loading.service(this.loadingOptions);

      this.exportBody.body = this.listQuery;
      console.log("导出表格请求body：", this.exportBody);

      reportToExcel(this.exportBody)
        .then((res) => {
          console.log("查询表格导出====", res);

          this.$nextTick(() => {
            loadingInstance.close();
          });

          let blob = new Blob([res], { type: "application/force-download" });
          console.log(blob);
          let fileReader = new FileReader();
          fileReader.readAsDataURL(blob);
          fileReader.onload = (e) => {
            let a = document.createElement("a");
            a.download = `易患人群管理统计表${moment(new Date()).format(
              "YYYYMMDDHHmm"
            )}.xlsx`;
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        })
        .catch((error) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });

          console.log(error);

          this.$message({
            message: "导出失败",
            type: "error",
          });
        });
    },
    // 获取机构数组
    input(value) {
      this.listQuery.managerHospitals = value;
    },
    getList() {
      if (this.listQuery.patientName == "") {
        this.listQuery.patientName = null;
      }

      if (this.listQuery.idcard == "") {
        this.listQuery.idcard = null;
      }

      if (this.scoreLevel == "2") {
        this.listQuery.scoreLe = 25;
        this.listQuery.scoreGt = 100;
      } else if (this.scoreLevel == "3") {
        this.listQuery.scoreLe = null;
        this.listQuery.scoreGt = 25;
      } else {
        this.listQuery.scoreLe = null;
        this.listQuery.scoreGt = null;
      }
      this.listLoading = true;
      getPatientEasyillDiabetsList(
        this.listQuery,
        this.pageNum,
        this.pageSize
      ).then((response) => {
        this.listLoading = false;
        console.log(response);
        if (response.msg == "success") {
          var data = response.data;
          this.list = data.records;
          this.total = data.total;
        }
      });
    },
    // 跳转至相应病人档案详情页
    patientsDetail(row) {
      let params = {
        healthNo: row.healthNo
      }
      getSearchList(params).then((res) => {
        if (res.msg == "success") {
          console.log("========", res, row)
          var data = res.data.records[0];
          this.patientDetailVisible = true;
          this.$nextTick(() => {
            this.$refs["PatientDetailRef"].init(data);
          });
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    getPatientDiabets(value) {
      if (value == "1") {
        return "有家族史";
      } else if (value == "2") {
        return "无家族史";
      } else {
        return "不详";
      }
    },
    formatPhone(card) {
      if (card == null) return "";

      var str = card;
      if (str.length == 11) {
        str = str.toString().replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
        return str;
      } else if (str.length == 8) {
        str =
          str.toString().substring(0, 2) + "****" + str.substr(str.length - 2);
        return str;
      } else {
        return str;
      }
    },
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
    getDate(day) {
      const now = new Date();
      const monthn = now.getMonth();
      const yearn = now.getFullYear();
      const daten = now.getDate() + day;
      var time = new Date();
      time.setFullYear(yearn, monthn, daten);
      time.setHours(0, 0, 0);

      var formatTime = time.Format("yyyy-MM-ddThh:mm:ss.SZ"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
      return formatTime;
    },
  },
};
</script>

<style lang="scss" scoped></style>
